import { useEffect } from 'react';
import { Observable } from '@/utils/observer/observer';

export const useSubscribe = (event: string, callback: (value: any) => void) => {
  useEffect(() => {
    const subscription = Observable.getInstance().subscribe(event, callback);
    return () => {
      Observable.getInstance().unsubscribe(subscription);
    };
  }, [event, callback]);
};
